export const isCommunity = (groupType) => {
  return groupType === "community";
};